// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"178":"26382f9d","531":"0dc89a54","977":"2269c216"}[chunkId] + ".chunk.js";
};